import { Dimensions } from 'react-native';

const { height: HEIGHT, width: WIDTH } = Dimensions.get('window');

const vh = HEIGHT / 100;
const vw = WIDTH / 100;

export { vh, vw };
